export default __webpack_public_path__ + "static/media/edu-2.335d24f4.jpg";